// extracted by mini-css-extract-plugin
module.exports = {"responsiveWrapper":"IFrame_responsiveWrapper__ls8_p","responsiveIFrame":"IFrame_responsiveIFrame__H2Fuw"};